import React, {useState, useEffect} from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import MetaInfo from './MetaInfo/MetaInfo';
//import { tl_data } from './translations.js';
import { TranslatableText } from '../../../../providers/LanguageProvider';
import bgVideo from './i/grass_fed_beef.mp4';
import bgVideoMobile from './i/mobile/grass_fed_beef_mb.mp4';
import beefSvg from './i/svg/grass_fed_beef.svg';
import beefSvgFr from './i/svg/grass_fed_beef_fr.svg';
import arrow from '../../../../assets/images/hero-arrow.png';
//import WhereBlock from '../WhereBlock/WhereBlock';
import vidPlaceHolderImg from './i/beef-guarantee.jpg';
import vidPlaceHolderImg_mb from './i/mobile/beef-guarantee.jpg';
import YouTube from 'react-youtube';
import Icon from '../../../../components/Icon/Icon';
import playIconSvg from '../../../../assets/images/play-icon.svg';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_beef_1.jpg';
import slide2 from './i/carousel_beef_2.jpg';
import slide3 from './i/carousel_beef_3.jpg';
import slide4 from './i/carousel_beef_4.jpg';
import slide5 from './i/carousel_beef_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Beef = (props) => {
    //console.log('beef props ',props);
    const [thePlayer, setThePlayer] = useState();
    const [playVideo ,setPlayVideo] = useState(false);
    const [youtubeVideoId, setYoutubeVideoId] = useState('IMYNlOUPO5E');
   
    const videoIdFr = 'bH4sLhyJTEA';

    let beefVideo = props.isDesktop ? bgVideo : bgVideoMobile;
    let vidPlaceHolder = props.isDesktop ? vidPlaceHolderImg : vidPlaceHolderImg_mb;

    useEffect(() => {
        if(props.lang === 'fr'){
            setYoutubeVideoId(videoIdFr)
        }
    },[props]);

    // Youtube options
    const opts = {
        height: ("100%"),
        width: ("100%"),
        playerVars: { // https://developers.google.com/youtube/player_parameters
            autoplay: 1
        }
    };
    
    const playTheVideo = () => {
        setPlayVideo(true);
        //thePlayer.playVideo();
    }

    const _onReady = (event) => {
        // access to player in all event handlers via event.target
      
        setThePlayer(event.target);
        //var thePlayer = event.target;
        //event.target.pauseVideo();
    }

    const stopVideo = (e) => {
        //console.log('stop video');
        thePlayer.pauseVideo();
        setPlayVideo(false);
    }

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food beef">

                <div className="intro-block">
                    <video id="video-bg" className="intro-bg-video"  autoPlay playsInline muted loop>
                        <source src={beefVideo} type="video/mp4" />
                    </video>
                
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    {props.lang === 'en' ? <img className="img-svg" src={beefSvg} alt={"beef"} /> : <img className="img-svg" src={beefSvgFr} alt={"beef"} />}
                    {props.lang === 'en' && <p>For us, great burgers come first. Since 2013 we’ve been serving beef raised without artificial hormones and steroids, and now all our beef is also grass-fed and grass-finished. Grass-fed and finished beef is as simple as it sounds — cattle only graze on grass and other forage, like hay, for their entire adult lives. We source our grass-fed and finished beef from select ranches in Canada, the US, Australia and New Zealand, and are committed to offering Canadians burgers they can confidently enjoy.</p>}
                    {props.lang === 'fr' && <p>Offrir de vrais bons burgers, c’est primordial pour nous. Depuis 2013, nous servons du bœuf sans hormones artificielles ou stéroïdes et maintenant, tout notre bœuf est nourri et engraissé à l’herbe. Le bœuf nourri et engraissé à l’herbe, c’est aussi simple que son nom le dit : le bétail est exclusivement nourri d’herbes et de foin tout au long de sa vie adulte. Notre bœuf nourri et engraissé à l’herbe provient d’élevages situés au Canada, aux États-Unis, en Australie et en Nouvelle-Zélande, qui s’engagent à offrir à nos invités, des burgers qu’ils peuvent déguster en toute confiance.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            {/* <WhereBlock ingredient="Beef" /> */}
            <div className="where-block">
                
                {props.lang !== 'fr' ?
                    <>
                        <h2>Where does our&nbsp;  
                            <span>beef come from?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où vient notre&nbsp;  
                            <span>bœuf?</span>
                        </h2>
                    </>
                }
            </div>

            <div className="blockwrap our-food beef video">
    
                   <img src={vidPlaceHolder} alt="Beef is good" onClick={playTheVideo} />

                  {playVideo ? <span className="btn-close" onClick={(e) => stopVideo(e) }><Icon type="x" /></span>
                  : <div className={`play-icon `} onClick={playTheVideo}><img src={playIconSvg} alt={'play video'} /></div>}
                    
                    {playVideo && <YouTube
                        videoId={youtubeVideoId}
                        opts={opts}
                        onReady={_onReady} src={beefVideo} type="video/mp4" />
                    }

                    {!playVideo && 
                        <div className="video-copy-container">
                            {props.lang !== 'fr' ?
                                <>
                                    <h3 className={``}>Keeping it Simple</h3>
                                    <p className={`video-copy `}>We're on a journey to exclusively source and serve 100% Canadian, grass-fed beef at our restaurants. Our Canadian rancher partners are proud to raise their cattle with a focus on regenerative agriculture, animal care and grassland management.</p>
                                </>
                                :
                                <>
                                    <h3>La simplicité a bien meilleur goût</h3>
                                    <p className="video-copy">Notre but est de pouvoir servir exclusivement du bœuf 100 % canadien dans tous nos restaurants. Nos producteurs canadiens sont fiers d’élever leur bœuf en priorisant le bien-être animal, l’agriculture régénératrice et une bonne gestion des pâturages.</p>
                                </>
                            }
                        </div>
                    }

            </div>

            <SliderWrap {...props} >

                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>98 RANCH</h3>
                                        <p>Ross and Christine are first generation Saskatchewan ranchers.</p>
                                    </>
                                :
                                    <>
                                        <h3>98 RANCH</h3>
                                        <p>Christine et Ross sont des éleveurs saskatchewanais de première génération.</p>
                                    </>
                            }
                        </div>
                    </div>
                  
                </div>
              
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NATURAL PROCESS</h3>
                                        <p>Their modern approach to ranching is to let nature do its job.</p>
                                    </>
                                :
                                    <>
                                        <h3>PROCESSUS NATUREL</h3>
                                        <p>Leur approche moderne d’élevage est de laisser la nature faire son travail.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
              
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>LOW IMPACT RANCHING</h3>
                                        <p>They focus on conserving the native grasslands and raising cattle that thrive on the Canadian Prairies.</p>
                                    </>
                                :
                                    <>
                                        <h3>ÉLEVAGE ÉCOLOGIQUE</h3>
                                        <p>Ils s’assurent de protéger les pâturages naturels et d’élever du bétail adapté aux Prairies canadiennes.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>

                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>RESPECTING THE LAND</h3>
                                        <p>They raise only as many cattle as the land can support, so the animals are always free to graze on fresh pastures.</p>
                                    </>
                                :
                                    <>
                                        <h3>RESPECT DE LA TERRE</h3>
                                        <p>Ils élèvent seulement la quantité de bétail que la terre peut accueillir, laissant aux animaux beaucoup de liberté.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>

                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>ECOSYSTEM</h3>
                                        <p>As stewards of the land, Ross and Christine keep it simple in order to maintain a sustainable ecosystem.</p>
                                    </>
                                :
                                    <>
                                        <h3>ÉCOSYSTÈME</h3>
                                        <p>En tant que gardiens de leurs terres, Ross et Christine prônent la simplicité pour maintenir un écosystème durable.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
              
            </SliderWrap>

            <div className=" blockwrap our-food beef-ranch-link">
                <p>
                <Link to={props.lang !== 'fr' ? '/en/canadian-grass-fed-beef' : '/fr/boeuf-nourri-herbe'}>
                    <TranslatableText
                        dictionary={{
                            en: "Are you a rancher and want to get involved? ",
                            fr: "Vous êtes agriculteur et aimeriez vous impliquer? "
                        }}
                    >
                    </TranslatableText>
                   
                        <Icon type="angled-arrow-inverted" />
                    </Link>
                </p>
            </div>

            <div className="blockwrap our-food faq-block">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/beef`}>
                    {props.lang !== 'fr' ? 
                        <><span>Beef</span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ sur notre</span> bœuf<Icon type=" gt-inverted" /></>
                    }
                </Link>
            </div>

            <IngredientsSlider currentPage="beef" {...props} />
            <MobileOrderBanner {...props} />
        </>

    )
}
export default Beef;